import React,{Component} from "react";

// reactstrap components
import {
  Col,
  Row,
  Progress,
  Button
} from "reactstrap";
import SpeechRecognition from 'react-speech-recognition';
import Dictaphone from "./Dictaphone.jsx";
import Sound from 'react-sound';
// import getBlobDuration from 'get-blob-duration';
import { getBlobURL, getFile, getDuration } from "util/blobUtils.js";
import {base,s3base} from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import MicRecorder from 'mic-recorder-to-mp3';
import "components/custom.css";
import SpeechToText from "./New/SpeechToText.jsx";
let Mp3Recorder = new MicRecorder({ bitRate: 128 });

class DescribeImage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      question:"",
      secondCount:25,
      recordCount:0,
      recordId:1,
      intervalId:0,
      duration:0,
      questionId:"",
      reset:false,
      trans:'',
      correctFlag:true,
      soundStatus:false,
      file:'',
      imageLoaded:true,
      saveTranscript: false,
      isProcessing: false
    };
    this.transcriptPromise = null;
    this.transcriptResolver = null;
  }

  componentDidMount() {
    console.log("I am DescribeIAmge from the Question")
    if (!this.props.answer) {
     var intervalId = setInterval(this.timer, 1000);
       this.setState({intervalId: intervalId});
    }
    navigator.getUserMedia({ audio: true },
      () => {
        this.setState({ isBlocked: false });
      },
      () => {
        this.setState({ isBlocked: true })
      },
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data) {
        if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
            clearInterval(state.intervalId);
            clearInterval(state.recordId);
            
            return {recordCount:0,isRecording:false,secondCount:25,questionId: props.data.id,blobURL:'',reset:true,imageLoaded:false,trans:'',duration:0,isProcessing: false};
        }else{
            if (!state.questionId) {
                return {questionId: props.data.id,imageLoaded:false};
            }
        }
        
        }
        
    
  }

  revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
        URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
          this.setState({ blobURL: '' });
      }
    }
  };

  start = () => {
    this.setState({ soundStatus: true});
  };

  handleSongFinishedPlaying = () =>{
    if (this.state.isBlocked) {
      console.log('Permission Denied');
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'en-GB' })
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true,blobURL:'',soundStatus:false});
        }).catch((e) => console.error(e));
    }
  }

  setTrans = (a)=>{
    if (this.state.trans != a) {
      this.setState({trans:a})  
    }
    
  }

  stop = async () => {
  // Working for: Practice mode
  let file = null;
  let duration = 0;

  // Step 1: Stop recording and get file + duration
  if (!this.state.isBlocked && this.state.isRecording) {
    try {
      const [buffer, blob] = await Mp3Recorder.stop().getMp3();
      this.revokeBlobURL();

      if (blob && blob.size > 0) {
        duration = await getDuration(blob);
        file = await getFile(blob, buffer, 'noname1'+this.state.questionId+'.mp3');
        const blobURL = await getBlobURL(blob, file);

        this.setState({
          blobURL,
          isRecording: false,
          recordCount: 100,
          file: file,
          duration
        });
      } else {
        this.setState({
          blobURL: '',
          isRecording: false,
          recordCount: 100,
          file: null
        });
      }
      SpeechRecognition.stopListening();
    } catch (e) {
      console.log(e);
    }
  } else {
    // Use existing state if already stopped
    file = this.state.file;
    duration = this.state.duration;
  }

  // Step 2: Start waiting for transcript
  this.transcriptPromise = new Promise((resolve) => {
    this.transcriptResolver = resolve;
  });

  // Step 3: Trigger transcript save
  this.setState({ saveTranscript: true });

  // Step 4: Wait for transcript
  const transcript = await this.transcriptPromise;

  // Step 5: NOW submit — all data ready!
  const payload = {
    data: file,
    audio_text: transcript,
    duration: duration
  };
  
  this.props.submit(payload, true);
  this.props.showResult();

  // Cleanup
  this.transcriptPromise = null;
  this.transcriptResolver = null;
};

  stopTest = async () => {
  // Working for: Mock Test mode
  console.log("stoptest called");
  
  if (this.state.isProcessing) return;

  let file = null;
  let duration = 0;

  // Step 1: Stop recording and get file + duration
  if (!this.state.isBlocked && this.state.isRecording) {
    this.setState({ isProcessing: true });
    
    try {
      const [buffer, blob] = await Mp3Recorder.stop().getMp3();
      this.revokeBlobURL();
      
      if (blob && blob.size > 0) {
        console.log("inside blob size");
        
        duration = await getDuration(blob);
        file = await getFile(blob, buffer, 'noname1.mp3');
        const blobURL = await getBlobURL(blob, file);
        
        this.setState({
          isRecording: false,
          recordCount: 100,
          duration,
          file,
          blobURL,
          isProcessing: false
        });
        
        console.log("inside if file,duration", file, duration);
        SpeechRecognition.stopListening();
      } else {
        console.log("inside stoptest else (no audio)");
        
        this.setState({
          duration: 0,
          file: null,
          blobURL: '',
          isRecording: false,
          recordCount: 100,
          isProcessing: false
        });
        SpeechRecognition.stopListening();
      }
    } catch (e) {
      console.log(e);
      this.setState({ isProcessing: false });
    }
  } else {
    // Use existing state if already stopped
    file = this.state.file;
    duration = this.state.duration;
  }

  // Step 2: Start waiting for transcript
  this.transcriptPromise = new Promise((resolve) => {
    this.transcriptResolver = resolve;
  });

  // Step 3: Trigger transcript save
  this.setState({ saveTranscript: true });

  // Step 4: Wait for transcript
  const transcript = await this.transcriptPromise;

  // Step 5: NOW submit — all data ready!
  if (this.props.testMode && !this.state.isProcessing) {
    const payload = {
      data: file,
      audio_text: transcript,
      duration: duration
    };
    
    console.log("Sending payload to nextQuestion:", payload);
    this.setState({ isProcessing: true });
    this.props.nextQuestion(payload);
    this.setState({ isProcessing: false });
  }

  // Cleanup
  this.transcriptPromise = null;
  this.transcriptResolver = null;
};

   setTranscript = (transcript) => {
  console.log("transcript received:", transcript);
  
  this.setState({
    trans: transcript,
    saveTranscript: false
  }, () => {
    // Resolve the waiting promise
    if (this.transcriptResolver) {
      this.transcriptResolver(transcript);
      this.transcriptResolver = null;
      this.transcriptPromise = null;
    }
  });
}
  updateCorrect = () =>{
     this.props.submit({'data':'', 'audio_text':'','duration':this.state.duration});
     this.setState({correctFlag:false})
  }

  skip = () => {
    clearInterval(this.state.intervalId);
    this.start();
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({recordId: recordId,secondCount:0});
  };

    timer = () => {
        if (this.state.secondCount === 1) {
            clearInterval(this.state.intervalId);
            this.start();
            var recordId = setInterval(this.timerRecord, 1000);
            this.setState({recordId: recordId});
        }
        this.setState({ secondCount: this.state.secondCount -1 });
    }



    timerRecord = () => {
    if (this.state.recordCount === 40) {
        clearInterval(this.state.recordId);
        if (!this.props.testMode) {
          this.stop();
        } else {
          this.stopTest();
        }
    }
    this.setState({ recordCount: this.state.recordCount + 1 });	
}

    componentWillUnmount = () => {
        clearInterval(this.state.intervalId);
    this.revokeBlobURL();
    }

  handleImageLoaded =() =>{
    this.setState({ imageLoaded: true });
  }
  
  componentDidUpdate(prevProps, prevState) {
  if (this.props.stopRecording && !prevProps.stopRecording) {
    this.stopTest();
  }
}
  
  render() {
    let question ="";
    // if (!this.state.imageLoaded) {
    //   const img = new Image();
    //   img.src = s3base + this.props.data.media_link;
    //   if (img.complete) {
    //     var intervalId = setInterval(this.timer, 1000);
    //     this.setState({intervalId: intervalId,reset:false,imageLoaded:true});
          
    //   }
    // }
    if (this.props.restart) {
      this.props.restartQue();
    }
    // if (this.props.stopRecording) {
    //   this.stopTest();      
    // }
    if (this.props.data) {
        question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();
      }
    }
    if (this.state.reset) {
        /*var intervalId = setInterval(this.timer, 1000);
        this.setState({intervalId: intervalId,reset:false});*/
    }
    if (this.state.isBlocked) {
      return (<NoMicrophone />);
    }
    
    return (
      <>
        {/* <Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} /> */}
        <SpeechToText
          saveTranscript={this.state.saveTranscript}
          setTranscript={this.setTranscript}/>
        <Col xs={12}>
            <h4 className="infoText"></h4>
        </Col>
        <Col xs={12}>
          <Row>
            <Col lg={6}>
              {/*{!this.state.imageLoaded && <div style={{margin:'145px'}}>Loading...</div>}
              {this.state.imageLoaded && this.props.data && <img alt="media-link" width="500" onLoad={this.handleImageLoaded} src={s3base + this.props.data.media_link} />}*/}
              <img
                alt="media-link"
                width="500"
                onLoad={this.handleImageLoaded}
                src={`data:image/png;base64, ${this.props.data.image}`}
              />  
            </Col>
            <div className="col-lg-6 p-0 text-center">
                  {!this.props.resultMode && 
                <div className="audio-box">
                  <h4>Recorded Answer</h4>
                  <p><strong>Current status:</strong></p>
                  <p>
                    {/* {this.state.blobURL === '' && this.state.isRecording ? "Recording started" : `Recording starts in ${this.state.secondCount} seconds`} */}
                    <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.blobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p>

                  </p>
                  {!this.props.testMode && this.state.blobURL === '' && !this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.skip} size="sm">Skip</Button>
                    </div>
                  }
                  <hr></hr>
                  {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
                  {!this.props.testMode && this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.stop} size="sm">Stop</Button>
                    </div>
                  }
                  <hr></hr>
                  <Progress color="info" value={(this.state.recordCount*2.5)} />
                  <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
                </div>
              }
                </div>
          </Row>
          
          <Col xs={12}>
            {this.state.blobURL && !this.props.testMode && 
              <audio src={this.state.blobURL} controls="controls" />
            }
          </Col>
        </Col> 
        
        <Col xs={12}>
          <h5>{question}</h5>
        </Col>

        {!this.props.resultMode && this.state.soundStatus && 
          <Sound url={`${s3base}/ptedata/ptemedia/beep.mp3`} playStatus={Sound.status.PLAYING} onFinishedPlaying={this.handleSongFinishedPlaying} />
        }
      </>
    );
  }
}
export default DescribeImage;